// extracted by mini-css-extract-plugin
module.exports = {"loading-spinner":"y0bBZqVp-108EN55ZIbu7"};